import { render, staticRenderFns } from "./MasterInsurance.vue?vue&type=template&id=c918110c&scoped=true"
import script from "./MasterInsurance.vue?vue&type=script&lang=js"
export * from "./MasterInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c918110c",
  null
  
)

export default component.exports